module.exports = "/img/s2o_logo.png?8652acf20ddcca8c7651a736453860bc";